import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./advertise.css";

const MetaAdvertiseProduct = () => {
  const { productId } = useParams();
  const history = useHistory();
  const { user, token: authToken, userLanguage } = useSelector((state) => state.auth);
  const t = {
    noAccess: { en: "You do not have access to this product", fr: "Vous n'avez pas acces a ce produit", es: "No tienes acceso a este producto", zh: "您无权访问此产品", pt: "Voce nao tem acesso a este produto", ar: "ليس لديك صلاحية الوصول لهذا المنتج" },
    productNotFound: { en: "Product not found", fr: "Produit introuvable", es: "Producto no encontrado", zh: "未找到产品", pt: "Produto nao encontrado", ar: "المنتج غير موجود" },
    couldNotStart: { en: "Could not start Meta connect", fr: "Impossible de demarrer la connexion Meta", es: "No se pudo iniciar la conexion con Meta", zh: "无法开始Meta连接", pt: "Nao foi possivel iniciar a conexao Meta", ar: "تعذر بدء اتصال ميتا" },
    connectFailed: { en: "Connect failed", fr: "Echec de connexion", es: "Conexion fallida", zh: "连接失败", pt: "Falha na conexao", ar: "فشل الاتصال" },
    catalogSelected: { en: "Catalog selected", fr: "Catalogue selectionne", es: "Catalogo seleccionado", zh: "目录已选择", pt: "Catalogo selecionado", ar: "تم اختيار الكتالوج" },
    failSetCatalog: { en: "Failed to set catalog", fr: "Echec de selection du catalogue", es: "Error al seleccionar catalogo", zh: "设置目录失败", pt: "Falha ao definir catalogo", ar: "فشل تعيين الكتالوج" },
    businessCatalogRequired: { en: "Business and catalog name are required", fr: "Le nom du business et du catalogue sont requis", es: "Se requieren negocio y nombre del catalogo", zh: "企业和目录名称为必填", pt: "Negocio e nome do catalogo sao obrigatorios", ar: "اسم النشاط والكتالوج مطلوبان" },
    catalogCreated: { en: "Catalog created", fr: "Catalogue cree", es: "Catalogo creado", zh: "目录已创建", pt: "Catalogo criado", ar: "تم إنشاء الكتالوج" },
    failCreateCatalog: { en: "Failed to create catalog", fr: "Echec de creation du catalogue", es: "Error al crear catalogo", zh: "创建目录失败", pt: "Falha ao criar catalogo", ar: "فشل إنشاء الكتالوج" },
    syncStarted: { en: "Sync started. Meta is processing your catalog update...", fr: "Synchronisation demarree. Meta traite la mise a jour...", es: "Sincronizacion iniciada. Meta esta procesando...", zh: "同步已开始，Meta正在处理更新...", pt: "Sincronizacao iniciada. A Meta esta processando...", ar: "بدأت المزامنة. ميتا تعالج التحديث..." },
    syncQueued: { en: "Sync queued. Please refresh in a few seconds to see the product in the catalog.", fr: "Sync en file d'attente. Rafraichissez dans quelques secondes.", es: "Sincronizacion en cola. Actualiza en unos segundos.", zh: "同步已排队，请几秒后刷新查看产品。", pt: "Sincronizacao em fila. Atualize em alguns segundos.", ar: "تمت جدولة المزامنة. حدّث بعد بضع ثوانٍ." },
    syncErrors: { en: "Meta sync finished with errors. Please try syncing again.", fr: "La sync Meta s'est terminee avec des erreurs.", es: "La sincronizacion de Meta finalizo con errores.", zh: "Meta同步完成但有错误，请重试。", pt: "A sincronizacao da Meta terminou com erros.", ar: "انتهت مزامنة ميتا مع أخطاء." },
    synced: { en: "Product synced to catalog", fr: "Produit synchronise au catalogue", es: "Producto sincronizado al catalogo", zh: "产品已同步到目录", pt: "Produto sincronizado ao catalogo", ar: "تمت مزامنة المنتج إلى الكتالوج" },
    noBatchResults: { en: "Meta did not return batch results. Please try syncing again.", fr: "Meta n'a pas renvoye les resultats du lot.", es: "Meta no devolvio resultados por lote.", zh: "Meta未返回批处理结果，请重试。", pt: "A Meta nao retornou resultados em lote.", ar: "لم تُرجع ميتا نتائج الدُفعة." },
    syncFailed: { en: "Sync failed", fr: "Echec de synchronisation", es: "Sincronizacion fallida", zh: "同步失败", pt: "Falha na sincronizacao", ar: "فشلت المزامنة" },
    selectCatalogFirst: { en: "Select a catalog and ensure product is synced", fr: "Selectionnez un catalogue et synchronisez le produit", es: "Selecciona un catalogo y sincroniza el producto", zh: "请先选择目录并同步产品", pt: "Selecione um catalogo e sincronize o produto", ar: "اختر كتالوجًا وتأكد من مزامنة المنتج" },
    campaignCreated: { en: "Campaign created", fr: "Campagne creee", es: "Campana creada", zh: "广告活动已创建", pt: "Campanha criada", ar: "تم إنشاء الحملة" },
    campaignCreateFailed: { en: "Campaign creation failed", fr: "La creation de la campagne a echoue", es: "Fallo la creacion de la campana", zh: "创建广告活动失败", pt: "Falha na criacao da campanha", ar: "فشل إنشاء الحملة" },
    loadingProduct: { en: "Loading product...", fr: "Chargement du produit...", es: "Cargando producto...", zh: "正在加载产品...", pt: "Carregando produto...", ar: "جارٍ تحميل المنتج..." },
    loginToAdvertise: { en: "Please log in to advertise products on Meta.", fr: "Veuillez vous connecter pour faire de la publicite sur Meta.", es: "Inicia sesion para anunciar productos en Meta.", zh: "请登录后在Meta上推广产品。", pt: "Faca login para anunciar produtos na Meta.", ar: "يرجى تسجيل الدخول للإعلان عن المنتجات على ميتا." },
    login: { en: "Log in", fr: "Se connecter", es: "Iniciar sesion", zh: "登录", pt: "Entrar", ar: "تسجيل الدخول" },
    notFoundOrNoAccess: { en: "Product not found or you do not have access.", fr: "Produit introuvable ou acces refuse.", es: "Producto no encontrado o sin acceso.", zh: "未找到产品或无访问权限。", pt: "Produto nao encontrado ou sem acesso.", ar: "المنتج غير موجود أو ليس لديك صلاحية." },
    productMustBeActive: {
      en: "Meta ads are available only for products with Active status (after admin approval). Please wait until your product is approved, then try again.",
      fr: "Les pubs Meta sont disponibles uniquement pour les produits au statut Actif (apres validation admin). Attendez l'approbation puis reessayez.",
      es: "Los anuncios en Meta solo estan disponibles para productos en estado Activo (tras la aprobacion del admin). Espere la aprobacion e intente de nuevo.",
      zh: "仅在商品为“激活”（管理员已通过）状态时可使用 Meta 广告。请通过审核后再试。",
      pt: "Anuncios na Meta ficam disponiveis apenas para produtos com status Ativo (aprovados pelo admin). Aguarde a aprovacao e tente de novo.",
      ar: "تتوفر إعلانات ميتا فقط للمنتجات ذات الحالة «نشط» (بعد موافقة المشرف). يُرجى انتظار الموافقة ثم المحاولة مرة أخرى.",
    },
    backToProducts: { en: "Back to Products", fr: "Retour aux produits", es: "Volver a Productos", zh: "返回产品页", pt: "Voltar aos produtos", ar: "العودة إلى المنتجات" },
    pageTitle: { en: "Advertise on Meta", fr: "Faire de la publicite sur Meta", es: "Anunciar en Meta", zh: "在Meta上投放广告", pt: "Anunciar na Meta", ar: "الإعلان على ميتا" },
    connectPrompt: { en: "Connect your Meta (Facebook) account to run ads for this product.", fr: "Connectez votre compte Meta (Facebook) pour annoncer ce produit.", es: "Conecta tu cuenta de Meta (Facebook) para anunciar este producto.", zh: "连接您的Meta（Facebook）账户以推广此产品。", pt: "Conecte sua conta Meta (Facebook) para anunciar este produto.", ar: "اربط حساب ميتا (فيسبوك) للإعلان عن هذا المنتج." },
    connectMeta: { en: "Connect Meta account", fr: "Connecter le compte Meta", es: "Conectar cuenta de Meta", zh: "连接Meta账户", pt: "Conectar conta Meta", ar: "ربط حساب ميتا" },
    adAccount: { en: "Ad account", fr: "Compte publicitaire", es: "Cuenta publicitaria", zh: "广告账户", pt: "Conta de anuncios", ar: "حساب الإعلانات" },
    selectCatalog: { en: "Select catalog", fr: "Selectionner un catalogue", es: "Seleccionar catalogo", zh: "选择目录", pt: "Selecionar catalogo", ar: "اختر الكتالوج" },
    noCatalogs: { en: "No product catalogs found. Create one below (or in Meta Business Manager).", fr: "Aucun catalogue trouve. Creez-en un ci-dessous (ou dans Meta Business Manager).", es: "No se encontraron catalogos. Crea uno abajo (o en Meta Business Manager).", zh: "未找到产品目录。请在下方创建（或在Meta商务管理平台创建）。", pt: "Nenhum catalogo encontrado. Crie um abaixo (ou no Meta Business Manager).", ar: "لم يتم العثور على كتالوجات منتجات. أنشئ واحدًا أدناه (أو في مدير أعمال ميتا)." },
    selectCatalogOption: { en: "Select catalog", fr: "Selectionner un catalogue", es: "Seleccionar catalogo", zh: "选择目录", pt: "Selecionar catalogo", ar: "اختر الكتالوج" },
    createNewCatalog: { en: "Create a new Meta catalog", fr: "Creer un nouveau catalogue Meta", es: "Crear un nuevo catalogo Meta", zh: "创建新的Meta目录", pt: "Criar novo catalogo Meta", ar: "إنشاء كتالوج ميتا جديد" },
    business: { en: "Business", fr: "Business", es: "Negocio", zh: "企业", pt: "Negocio", ar: "النشاط التجاري" },
    noBusiness: { en: "No businesses found for this Meta user. Add a Business in Meta Business Manager.", fr: "Aucun business trouve pour cet utilisateur Meta.", es: "No se encontraron negocios para este usuario de Meta.", zh: "该Meta用户未找到企业，请先在Meta商务管理平台添加。", pt: "Nenhum negocio encontrado para este usuario Meta.", ar: "لم يتم العثور على نشاط تجاري لهذا المستخدم في ميتا." },
    catalogName: { en: "Catalog name", fr: "Nom du catalogue", es: "Nombre del catalogo", zh: "目录名称", pt: "Nome do catalogo", ar: "اسم الكتالوج" },
    catalogNamePlaceholder: { en: "My Product Catalog", fr: "Mon catalogue produits", es: "Mi catalogo de productos", zh: "我的产品目录", pt: "Meu catalogo de produtos", ar: "كتالوج منتجاتي" },
    vertical: { en: "Vertical", fr: "Vertical", es: "Vertical", zh: "垂直领域", pt: "Vertical", ar: "القطاع" },
    creating: { en: "Creating...", fr: "Creation...", es: "Creando...", zh: "创建中...", pt: "Criando...", ar: "جارٍ الإنشاء..." },
    createCatalog: { en: "Create catalog", fr: "Creer un catalogue", es: "Crear catalogo", zh: "创建目录", pt: "Criar catalogo", ar: "إنشاء كتالوج" },
    syncing: { en: "Syncing...", fr: "Synchronisation...", es: "Sincronizando...", zh: "同步中...", pt: "Sincronizando...", ar: "جارٍ المزامنة..." },
    syncProduct: { en: "Sync this product to catalog", fr: "Synchroniser ce produit au catalogue", es: "Sincronizar este producto al catalogo", zh: "同步此产品到目录", pt: "Sincronizar este produto no catalogo", ar: "مزامنة هذا المنتج إلى الكتالوج" },
    campaignName: { en: "Campaign name", fr: "Nom de la campagne", es: "Nombre de la campana", zh: "广告活动名称", pt: "Nome da campanha", ar: "اسم الحملة" },
    dailyBudget: { en: "Daily budget (USD)", fr: "Budget quotidien (USD)", es: "Presupuesto diario (USD)", zh: "每日预算（USD）", pt: "Orcamento diario (USD)", ar: "الميزانية اليومية (USD)" },
    ageMin: { en: "Age min", fr: "Age minimum", es: "Edad minima", zh: "最小年龄", pt: "Idade minima", ar: "الحد الأدنى للعمر" },
    ageMax: { en: "Age max", fr: "Age maximum", es: "Edad maxima", zh: "最大年龄", pt: "Idade maxima", ar: "الحد الأقصى للعمر" },
    landingUrl: { en: "Landing URL (optional)", fr: "URL de destination (optionnel)", es: "URL de destino (opcional)", zh: "落地页URL（可选）", pt: "URL de destino (opcional)", ar: "رابط الصفحة المقصودة (اختياري)" },
    productPageUrl: { en: "Product page URL", fr: "URL de la page produit", es: "URL de la pagina del producto", zh: "产品页面URL", pt: "URL da pagina do produto", ar: "رابط صفحة المنتج" },
    startDate: { en: "Start date (optional)", fr: "Date de debut (optionnel)", es: "Fecha de inicio (opcional)", zh: "开始日期（可选）", pt: "Data de inicio (opcional)", ar: "تاريخ البدء (اختياري)" },
    endDate: { en: "End date (optional)", fr: "Date de fin (optionnel)", es: "Fecha de fin (opcional)", zh: "结束日期（可选）", pt: "Data de termino (opcional)", ar: "تاريخ الانتهاء (اختياري)" },
    createMetaCampaign: { en: "Create Meta campaign", fr: "Creer une campagne Meta", es: "Crear campana de Meta", zh: "创建Meta广告活动", pt: "Criar campanha Meta", ar: "إنشاء حملة ميتا" },
    cancel: { en: "Cancel", fr: "Annuler", es: "Cancelar", zh: "取消", pt: "Cancelar", ar: "إلغاء" },
  };
  const currentUserId = (user && (user._id || user.id)) || "";
  // Some Input events (especially paste/date/select) can be inconsistent.
  // Keep this resilient so typing always updates state.
  const evValue = (e) => {
    if (typeof e === "string" || typeof e === "number") return e;
    if (!e) return undefined;
    const v =
      e?.target?.value !== undefined
        ? e.target.value
        : e?.currentTarget?.value !== undefined
        ? e.currentTarget.value
        : e?.value;
    return v;
  };
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [catalogs, setCatalogs] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [catalogLoading, setCatalogLoading] = useState(false);
  const [syncingProduct, setSyncingProduct] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [creatingCatalog, setCreatingCatalog] = useState(false);
  const [newCatalog, setNewCatalog] = useState({
    businessId: "",
    name: "",
    vertical: "commerce",
  });
  const [metaProductId, setMetaProductId] = useState("");
  const [form, setForm] = useState({
    name: "",
    dailyBudget: 10,
    ageMin: 18,
    ageMax: 65,
    catalogLandingUrl: "",
    startDate: "",
    endDate: "",
  });

  const headers = () => ({ Authorization: `Bearer ${authToken}` });

  useEffect(() => {
    if (!productId || !authToken || !currentUserId) return;
    axios
      .get(`/product/get/${productId}`, { headers: headers() })
      .then((res) => {
        const data = res.data.data;
        if (!data) {
          setProduct(null);
          return;
        }
        const sellerId = data.sellerId && (data.sellerId._id || data.sellerId);
        if (sellerId && String(sellerId) !== String(currentUserId)) {
          toast.error(t.noAccess[userLanguage] || t.noAccess.en);
          setProduct(null);
          return;
        }
        setProduct(data);
        const defaultLandingUrl =
          data.productUrl || `${window.location.origin}/productdetail/${data._id}`;
        setForm((f) => ({
          ...f,
          name: `Campaign - ${(data.name || "").slice(0, 40)}`,
          catalogLandingUrl: defaultLandingUrl,
        }));
      })
      .catch(() => {
        toast.error(t.productNotFound[userLanguage] || t.productNotFound.en);
        setProduct(null);
      })
      .finally(() => setLoading(false));
  }, [productId, authToken, currentUserId]);

  useEffect(() => {
    if (!authToken) return;
    axios
      .get("/ad-accounts", { headers: headers() })
      .then((res) => {
        const list = res.data.data || [];
        setAdAccounts(list);
        if (list.length > 0 && !selectedAccount) setSelectedAccount(list[0]);
      })
      .catch(() => setAdAccounts([]));
  }, [authToken]);

  useEffect(() => {
    if (!selectedAccount || !selectedAccount.id) return;
    setCatalogLoading(true);
    axios
      .get(`/ad-accounts/${selectedAccount.id}/catalogs`, { headers: headers() })
      .then((res) => {
        setCatalogs(res.data.data || []);
        const biz = res.data.businesses || [];
        setBusinesses(biz);
        if (!newCatalog.businessId && biz.length > 0) {
          setNewCatalog((p) => ({ ...p, businessId: biz[0].id }));
        }
      })
      .catch(() => setCatalogs([]))
      .finally(() => setCatalogLoading(false));
  }, [selectedAccount, authToken]);

  const hasCatalog = selectedAccount && selectedAccount.metaCatalogId;
  const catalogList = catalogs;

  const getRetailerId = (p) => {
    const base = (p && (p.displayId || p._id)) ? String(p.displayId || p._id) : "";
    if (!base) return "";
    return base.startsWith("prod_") ? base : `prod_${base}`;
  };

  const getProductLocations = () => {
    // Reuse product-level geo when available, otherwise fallback.
    const candidates = [
      product?.country,
      product?.shippingCountry,
      product?.location?.country,
      product?.residencyData?.country,
    ].filter(Boolean);
    if (candidates.length === 0) return ["US"];
    return [...new Set(candidates.map((c) => String(c).trim().toUpperCase()))];
  };

  const connectMeta = () => {
    axios
      .get("/auth/meta-ads/connect", { headers: headers() })
      .then((res) => {
        if (res.data && res.data.url) window.location.href = res.data.url;
        else toast.error(t.couldNotStart[userLanguage] || t.couldNotStart.en);
      })
      .catch(() => toast.error(t.connectFailed[userLanguage] || t.connectFailed.en));
  };

  const selectCatalog = (catalogId) => {
    if (!selectedAccount) return;
    axios
      .patch(`/ad-accounts/${selectedAccount.id}/catalog`, { catalog_id: catalogId }, { headers: headers() })
      .then(() => {
        setSelectedAccount((a) => (a ? { ...a, metaCatalogId: catalogId } : a));
        toast.success(t.catalogSelected[userLanguage] || t.catalogSelected.en);
      })
      .catch((e) => toast.error(e.response?.data?.message || t.failSetCatalog[userLanguage] || t.failSetCatalog.en));
  };

  const createCatalog = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    if (!selectedAccount) return;

    const formEl = e && e.currentTarget ? e.currentTarget : null;
    const elements = formEl && formEl.elements ? formEl.elements : {};
    const businessId = elements.businessId?.value || newCatalog.businessId;
    const name = elements.catalogName?.value || newCatalog.name;
    const vertical = elements.vertical?.value || newCatalog.vertical;

    if (!businessId || !name) {
      toast.error(t.businessCatalogRequired[userLanguage] || t.businessCatalogRequired.en);
      return;
    }
    setCreatingCatalog(true);
    axios
      .post(
        `/ad-accounts/${selectedAccount.id}/catalogs`,
        {
          business_id: businessId,
          name,
          vertical,
        },
        { headers: headers() }
      )
      .then((res) => {
        const createdId = res.data?.data?.id;
        toast.success(t.catalogCreated[userLanguage] || t.catalogCreated.en);
        // refresh catalogs then select it
        return axios.get(`/ad-accounts/${selectedAccount.id}/catalogs`, { headers: headers() }).then((r) => {
          setCatalogs(r.data.data || []);
          setBusinesses(r.data.businesses || []);
          if (createdId) selectCatalog(createdId);
          setNewCatalog((p) => ({ ...p, name: "" }));
        });
      })
      .catch((e) => toast.error(e.response?.data?.message || t.failCreateCatalog[userLanguage] || t.failCreateCatalog.en))
      .finally(() => setCreatingCatalog(false));
  };

  const ensureProductInCatalog = () => {
    if (!selectedAccount || !selectedAccount.metaCatalogId || !product) return;
    setSyncingProduct(true);
    const retailerId = getRetailerId(product);
    const legacyIds = Array.from(
      new Set(
        [
          product._id,
          product.displayId,
          `prod_${product._id}`,
          product.displayId ? `prod_${product.displayId}` : "",
        ]
          .map((x) => String(x || "").trim())
          .filter(Boolean)
      )
    );
    const payload = {
      catalog_id: selectedAccount.metaCatalogId,
      upsert: true,
      legacy_retailer_ids: legacyIds,
      products: [
        {
          retailer_id: retailerId,
          name: product.name || "",
          description: (product.description || "").slice(0, 5000),
          url: product.productUrl || window.location.origin + "/productdetail/" + product._id,
          image_url: (product.images && product.images[0]) || "",
          price: product.salesPrice != null ? product.salesPrice : product.regularPrice,
          brand: product.brand || "",
        },
      ],
    };
    axios
      .post(`/ad-accounts/${selectedAccount.id}/catalogs/products`, payload, { headers: headers() })
      .then(async (res) => {
        // Surface Meta batch errors (items_batch can return 200 with per-item failures).
        const responses = res?.data?.data || [];
        const handles = res?.data?.raw?.handles || [];
        const errs = (responses || [])
          .map((r) => r?.body?.error?.message || r?.body?.error || null)
          .filter(Boolean);
        if (errs.length) {
          toast.error(errs[0]);
          return;
        }

        if (handles && handles.length > 0) {
          toast.info(t.syncStarted[userLanguage] || t.syncStarted.en);
          // Poll Meta batch status until finished (or timeout), then refresh products.
          const handle = handles[0];
          const startedAt = Date.now();
          const timeoutMs = 45000;
          let status = "unknown";
          let finishedWithErrors = false;
          while (Date.now() - startedAt < timeoutMs) {
            try {
              const s = await axios.get(
                `/ad-accounts/${selectedAccount.id}/catalogs/batch-status?catalog_id=${encodeURIComponent(
                  selectedAccount.metaCatalogId
                )}&handle=${encodeURIComponent(handle)}`,
                { headers: headers() }
              );
              const item = (s.data?.data || [])[0] || {};
              status = item.status || status;
              if (status === "finished") {
                const errorsCount = Number(item.errors_total_count || 0);
                finishedWithErrors = errorsCount > 0;
                break;
              }
            } catch (_) {}
            // wait 2s
            // eslint-disable-next-line no-await-in-loop
            await new Promise((r) => setTimeout(r, 2000));
          }

          if (status !== "finished") {
            toast.info(t.syncQueued[userLanguage] || t.syncQueued.en);
          } else if (finishedWithErrors) {
            toast.error(t.syncErrors[userLanguage] || t.syncErrors.en);
          } else {
            toast.success(t.synced[userLanguage] || t.synced.en);
          }
        } else if (!responses || responses.length === 0) {
          // No handles and no per-item responses — treat as unknown.
          toast.error(t.noBatchResults[userLanguage] || t.noBatchResults.en);
          return;
        } else {
          toast.success(t.synced[userLanguage] || t.synced.en);
        }
        // Try to resolve Meta product id for more reliable product_set filtering later.
        try {
          const r = await axios.get(
            `/ad-accounts/${selectedAccount.id}/catalogs/products?catalog_id=${encodeURIComponent(selectedAccount.metaCatalogId)}`,
            { headers: headers() }
          );
          const list = r.data?.data || [];
          const match = list.find((x) => String(x.retailer_id) === String(retailerId));
          setMetaProductId(match?.id || "");
        } catch (_) {
          // non-fatal; retailer_id filter still works
          setMetaProductId("");
        }
      })
      .catch((e) => toast.error(e.response?.data?.message || t.syncFailed[userLanguage] || t.syncFailed.en))
      .finally(() => setSyncingProduct(false));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formEl = e.currentTarget;
    const elements = formEl && formEl.elements ? formEl.elements : {};
    const getElValue = (key) => (elements[key] && elements[key].value !== undefined ? elements[key].value : undefined);

    const campaignName = getElValue("campaignName");
    const dailyBudget = getElValue("dailyBudget");
    const ageMin = getElValue("ageMin");
    const ageMax = getElValue("ageMax");
    const landingUrl = getElValue("landingUrl");
    const startDate = getElValue("startDate");
    const endDate = getElValue("endDate");

    const payloadForm = {
      name: campaignName !== undefined ? campaignName : form.name,
      dailyBudget: dailyBudget !== undefined ? dailyBudget : form.dailyBudget,
      ageMin: ageMin !== undefined ? ageMin : form.ageMin,
      ageMax: ageMax !== undefined ? ageMax : form.ageMax,
      catalogLandingUrl: landingUrl !== undefined ? landingUrl : form.catalogLandingUrl,
      startDate: startDate !== undefined ? startDate : form.startDate,
      endDate: endDate !== undefined ? endDate : form.endDate,
    };
    if (!selectedAccount || !selectedAccount.metaCatalogId || !product) {
      toast.error(t.selectCatalogFirst[userLanguage] || t.selectCatalogFirst.en);
      return;
    }
    setSubmitting(true);
    const retailerId = getRetailerId(product);
    const payload = {
      name: payloadForm.name,
      metaCatalogId: selectedAccount.metaCatalogId,
      metaProductRetailerId: retailerId,
      ...(metaProductId ? { metaProductId } : {}),
      localProductId: product._id,
      budget: { daily: Number(payloadForm.dailyBudget) },
      targetAudience: {
        ageMin: Number(payloadForm.ageMin),
        ageMax: Number(payloadForm.ageMax),
        locations: getProductLocations(),
      },
      catalogLandingUrl:
        payloadForm.catalogLandingUrl ||
        product.productUrl ||
        `${window.location.origin}/productdetail/${product._id}`,
      startDate: payloadForm.startDate || undefined,
      endDate: payloadForm.endDate || undefined,
    };
    axios
      .post(`/ad-accounts/${selectedAccount.id}/campaigns`, payload, { headers: headers() })
      .then(() => {
        toast.success(t.campaignCreated[userLanguage] || t.campaignCreated.en);
        history.push("/seller/social-advertisement");
      })
      .catch((e) => toast.error(e.response?.data?.message || t.campaignCreateFailed[userLanguage] || t.campaignCreateFailed.en))
      .finally(() => setSubmitting(false));
  };

  if (loading) {
    return (
      <div className="animated fadeIn p-4 text-center">
        <i className="fas fa-spinner fa-pulse fa-2x" style={{ color: "var(--primary)" }} aria-hidden />
        <p className="mt-2">{t.loadingProduct[userLanguage] || t.loadingProduct.en}</p>
      </div>
    );
  }
  if (!currentUserId) {
    return (
      <div className="animated fadeIn p-4">
        <Card>
          <CardBody>
            <p>{t.loginToAdvertise[userLanguage] || t.loginToAdvertise.en}</p>
            <Button color="primary" onClick={() => history.push("/auth/login")}>
              {t.login[userLanguage] || t.login.en}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }
  if (!product) {
    return (
      <div className="animated fadeIn p-4">
        <Card>
          <CardBody>
            <p>{t.notFoundOrNoAccess[userLanguage] || t.notFoundOrNoAccess.en}</p>
            <Button color="primary" onClick={() => history.push("/seller/products")}>
              {t.backToProducts[userLanguage] || t.backToProducts.en}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }

  const productIsActive = String(product.status || "").trim().toLowerCase() === "active";
  if (!productIsActive) {
    return (
      <div className="animated fadeIn p-4">
        <Card>
          <CardBody>
            <p>{t.productMustBeActive[userLanguage] || t.productMustBeActive.en}</p>
            <Button color="primary" onClick={() => history.push("/seller/products")}>
              {t.backToProducts[userLanguage] || t.backToProducts.en}
            </Button>
          </CardBody>
        </Card>
      </div>
    );
  }

  return (
    <div className="animated fadeIn">
      <ToastContainer autoClose={5000} />
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <b>{t.pageTitle[userLanguage] || t.pageTitle.en} — {product.name}</b>
            </CardHeader>
            <CardBody>
              {adAccounts.length === 0 ? (
                <div>
                  <p>{t.connectPrompt[userLanguage] || t.connectPrompt.en}</p>
                  <Button color="primary" onClick={connectMeta}>
                    {t.connectMeta[userLanguage] || t.connectMeta.en}
                  </Button>
                </div>
              ) : (
                <>
                  <FormGroup>
                    <Label>{t.adAccount[userLanguage] || t.adAccount.en}</Label>
                    <Input
                      type="select"
                      value={selectedAccount ? selectedAccount.id : ""}
                      onChange={(e) => {
                        const id = evValue(e);
                        setSelectedAccount(adAccounts.find((a) => a.id === id) || null);
                      }}
                    >
                      {adAccounts.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.accountName || a.accountId}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label>{t.selectCatalog[userLanguage] || t.selectCatalog.en}</Label>
                    {catalogLoading ? (
                      <i className="fas fa-spinner fa-pulse" aria-hidden />
                    ) : catalogList.length === 0 ? (
                      <p className="text-muted">{t.noCatalogs[userLanguage] || t.noCatalogs.en}</p>
                    ) : (
                      <Input
                        type="select"
                        value={selectedAccount?.metaCatalogId || ""}
                        onChange={(e) => selectCatalog(evValue(e))}
                      >
                        <option value="">— {t.selectCatalogOption[userLanguage] || t.selectCatalogOption.en} —</option>
                        {catalogList.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </Input>
                    )}
                  </FormGroup>

                  {!hasCatalog && (
                    <Card className="mt-3">
                      <CardHeader>
                        <b>{t.createNewCatalog[userLanguage] || t.createNewCatalog.en}</b>
                      </CardHeader>
                      <CardBody>
                        <Form onSubmit={createCatalog}>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{t.business[userLanguage] || t.business.en}</Label>
                              <Input
                                type="select"
                                name="businessId"
                                defaultValue={newCatalog.businessId}
                              >
                                {(businesses || []).map((b) => (
                                  <option key={b.id} value={b.id}>
                                    {b.name} ({b.id})
                                  </option>
                                ))}
                              </Input>
                              {(!businesses || businesses.length === 0) && (
                                <small className="text-muted">
                                  {t.noBusiness[userLanguage] || t.noBusiness.en}
                                </small>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{t.catalogName[userLanguage] || t.catalogName.en}</Label>
                              <Input
                                name="catalogName"
                                defaultValue={newCatalog.name}
                                onChange={(e) => {
                                  const v = evValue(e);
                                  setNewCatalog((p) => ({ ...p, name: v !== undefined ? v : p.name }));
                                }}
                                placeholder={t.catalogNamePlaceholder[userLanguage] || t.catalogNamePlaceholder.en}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <Label>{t.vertical[userLanguage] || t.vertical.en}</Label>
                          <Input
                            type="select"
                            name="vertical"
                            defaultValue={newCatalog.vertical}
                          >
                            <option value="commerce">commerce</option>
                            <option value="offline_commerce">offline_commerce</option>
                            <option value="transactable_items">transactable_items</option>
                            <option value="vehicle_offers">vehicle_offers</option>
                            <option value="jobs">jobs</option>
                            <option value="real_estate">home_listings</option>
                            <option value="travel">destinations</option>
                          </Input>
                        </FormGroup>
                        <Button type="submit" color="primary" disabled={creatingCatalog}>
                          {creatingCatalog ? t.creating[userLanguage] || t.creating.en : t.createCatalog[userLanguage] || t.createCatalog.en}
                        </Button>
                        </Form>
                      </CardBody>
                    </Card>
                  )}

                  {hasCatalog && (
                    <>
                      <FormGroup>
                        <Button color="secondary" size="sm" onClick={ensureProductInCatalog} disabled={syncingProduct}>
                          {syncingProduct ? t.syncing[userLanguage] || t.syncing.en : t.syncProduct[userLanguage] || t.syncProduct.en}
                        </Button>
                      </FormGroup>

                      <Form onSubmit={onSubmit}>
                        <FormGroup>
                          <Label>{t.campaignName[userLanguage] || t.campaignName.en}</Label>
                          <Input
                            name="campaignName"
                            defaultValue={form.name}
                            onChange={(e) => {
                              const v = evValue(e);
                              setForm((f) => ({ ...f, name: v !== undefined ? v : f.name }));
                            }}
                            required
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label>{t.dailyBudget[userLanguage] || t.dailyBudget.en}</Label>
                          <Input
                            type="number"
                            min={1}
                            step={1}
                            name="dailyBudget"
                            defaultValue={form.dailyBudget}
                            onChange={(e) => {
                              const v = evValue(e);
                              setForm((f) => ({ ...f, dailyBudget: v !== undefined ? v : f.dailyBudget }));
                            }}
                          />
                        </FormGroup>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{t.ageMin[userLanguage] || t.ageMin.en}</Label>
                              <Input
                                type="number"
                                min={18}
                                max={65}
                                name="ageMin"
                                defaultValue={form.ageMin}
                                onChange={(e) => {
                                  const v = evValue(e);
                                  setForm((f) => ({ ...f, ageMin: v !== undefined ? v : f.ageMin }));
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{t.ageMax[userLanguage] || t.ageMax.en}</Label>
                              <Input
                                type="number"
                                min={18}
                                max={65}
                                name="ageMax"
                                defaultValue={form.ageMax}
                                onChange={(e) => {
                                  const v = evValue(e);
                                  setForm((f) => ({ ...f, ageMax: v !== undefined ? v : f.ageMax }));
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <Label>{t.landingUrl[userLanguage] || t.landingUrl.en}</Label>
                          <Input
                            type="url"
                            name="landingUrl"
                            defaultValue={form.catalogLandingUrl}
                            onChange={(e) => {
                              const v = evValue(e);
                              setForm((f) => ({ ...f, catalogLandingUrl: v !== undefined ? v : f.catalogLandingUrl }));
                            }}
                            placeholder={product.productUrl || t.productPageUrl[userLanguage] || t.productPageUrl.en}
                          />
                        </FormGroup>
                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{t.startDate[userLanguage] || t.startDate.en}</Label>
                              <Input
                                type="date"
                                name="startDate"
                                defaultValue={form.startDate}
                                onChange={(e) => {
                                  const v = evValue(e);
                                  setForm((f) => ({ ...f, startDate: v !== undefined ? v : f.startDate }));
                                }}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>{t.endDate[userLanguage] || t.endDate.en}</Label>
                              <Input
                                type="date"
                                name="endDate"
                                defaultValue={form.endDate}
                                onChange={(e) => {
                                  const v = evValue(e);
                                  setForm((f) => ({ ...f, endDate: v !== undefined ? v : f.endDate }));
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Button type="submit" color="primary" disabled={submitting}>
                          {submitting ? t.creating[userLanguage] || t.creating.en : t.createMetaCampaign[userLanguage] || t.createMetaCampaign.en}
                        </Button>
                        <Button color="secondary" className="ml-2" onClick={() => history.push("/seller/products")}>
                          {t.cancel[userLanguage] || t.cancel.en}
                        </Button>
                      </Form>
                    </>
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MetaAdvertiseProduct;
